/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Staatsexamen_Lehramt23Inputs */

const en__field_enum_tuda_staatsexamen_lehramt23 = /** @type {(inputs: _Field_Enum_Tuda_Staatsexamen_Lehramt23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Lehramt`)
};

const de__field_enum_tuda_staatsexamen_lehramt23 = /** @type {(inputs: _Field_Enum_Tuda_Staatsexamen_Lehramt23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Lehramt`)
};

/**
* | output |
* | --- |
* | "Staatsexamen Lehramt" |
*
* @param {_Field_Enum_Tuda_Staatsexamen_Lehramt23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_staatsexamen_lehramt23 = /** @type {((inputs?: _Field_Enum_Tuda_Staatsexamen_Lehramt23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Staatsexamen_Lehramt23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_staatsexamen_lehramt23(inputs)
	return de__field_enum_tuda_staatsexamen_lehramt23(inputs)
});
export { _field_enum_tuda_staatsexamen_lehramt23 as "_field_enum_TUDA_STAATSEXAMEN_LEHRAMT" }